import type { GetStaticProps } from 'next'

import { groupBy } from '@/utils/gropuBy'
import { WordPressApiClient } from '@/utils/WordPressApiClient'

export type AccordionProps = {
  accordionTitle: string
  accordionItems: {
    id: string
    fileName: string
    filePath: string
  }[]
  isDefaultOpen: boolean
}

export { MonthlySalesPage as default } from '@/components/enpages/Ir/Financial/MonthlySales'

export const getStaticProps: GetStaticProps = async () => {
  const wpClient = new WordPressApiClient()
  const [monthlySales, monthlyPdfEN] = await Promise.all([
    wpClient.fetchMonthlySalesTable(),
    wpClient.fetchMonthlySalesPdfEn(),
  ])

  const yearPdfList = groupBy(monthlyPdfEN, (monthlyItem) => monthlyItem.year)
  const yearPdf: Array<AccordionProps> = []
  const keyList: Array<string> = []

  for (const key in yearPdfList) {
    keyList.push(key)
  }
  keyList.sort().reverse()

  for (let i = 0; i < keyList.length; i++) {
    let isOpen = true
    const tempYearPdf = yearPdfList[keyList[i]].sort(
      (a, b) => a.index - b.index
    )
    const tempAccordionItem: Array<{
      id: string
      fileName: string
      filePath: string
    }> = []

    if (i > 0) {
      isOpen = false
    }

    for (let j = 0; j < tempYearPdf.length; j++) {
      tempAccordionItem.push({
        id: tempYearPdf[j]._id,
        fileName: tempYearPdf[j].title,
        filePath: tempYearPdf[j].monthlyReportPDF.src,
      })
    }

    yearPdf.push({
      isDefaultOpen: isOpen,
      accordionTitle: keyList[i],
      accordionItems: tempAccordionItem,
    })
  }

  return {
    props: {
      monthlySales: monthlySales[0],
      yearsPdf: yearPdf,
    },
  }
}
